/** @type {import('next-seo').DefaultSeoProps} */
export default {
  defaultTitle: 'Swap',
  title: 'Swap',
  titleTemplate: '%s | Zenlink',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@ZenlinkPro',
    site: '@ZenlinkPro',
  },
}
